export const globalStyles = {
  colors: {
    gray: {
      700: "#1f2733",
      800: "#141a23",
      900: "#0d1117",
    },
    brand: {
      50: "#e8f5e9",
      100: "#c8e6c9",
      200: "#4ade80",
      300: "#22c55e",
      400: "#16a34a",
      500: "#15803d",
      600: "#166534",
      700: "#14532d",
      800: "#1a3d2e",
      900: "#0f2419"
    },
  },
  styles: {
    global: (props) => ({
      body: {
        fontFamily: "'Inter', 'Plus Jakarta Display', sans-serif",
        // Background géré dynamiquement via ThemeContext
      },
      "*::placeholder": {
        color: "gray.500",
      },
      html: {
        fontFamily: "'Inter', 'Plus Jakarta Display', sans-serif",
      },
      /* Custom scrollbar */
      "::-webkit-scrollbar": {
        width: "8px",
        height: "8px",
      },
      "::-webkit-scrollbar-track": {
        background: "#0d1117",
      },
      "::-webkit-scrollbar-thumb": {
        background: "#1e3a2f",
        borderRadius: "4px",
      },
      "::-webkit-scrollbar-thumb:hover": {
        background: "#22c55e",
      },
      /* Mobile Select dropdown styling */
      "select": {
        colorScheme: "dark",
      },
      "select option": {
        background: "#0f1a2a",
        color: "#ffffff",
      },
      "select optgroup": {
        background: "#0f1a2a",
        color: "#ffffff",
      },
    }),
  },
};
